module.exports = __webpack_public_path__ + "img/mug-saucer.63ab830e.svg";